<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p>Twenty-eight years ago, I never thought I would be where I am today; not only in the martial arts, but in life in general. The martial arts continue to be a heart filled passion of mine, of which I plan to continue in my journey until I am no longer able.</p>
<p>I hope that this book serves as an inspiration for many to consider taking up some sort of martial art in the future, and for those who already train, I hope you are inspired to train harder. Martial arts are a gift to be given and shared throughout the world.</p>
<p>Take what you learn and share it with others, for sharing and spreading your knowledge is what keeps that knowledge alive and forever growing to other, more exciting levels. As instructors, it is our duty to educate and inspire others, not just through the amazing physical feats that martial arts provides, but by the teaching and education of life skills. Skills which can, and hopefully will be, used for the remainder of the practitioner’s life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?29c79e16